<template>
  <div class="info-page">
    <crumbs title="角色管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>角色信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="角色名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入角色名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="角色描述" prop="description">
              <el-input
                v-model="form.description"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入角色描述"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="角色权限" prop="checkList">
              <el-tree
                class="my-tree"
                ref="tree"
                :data="authList"
                :props="{
                  children: 'dataList',
                  label: 'name'
                }"
                empty-text="数据加载中"
                node-key="id"
                show-checkbox
                default-expand-all
                :default-checked-keys="form.checkList"
                @check="handleCheck"
              >
              </el-tree>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="启用状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "roleInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        name: "",
        description: "",
        status: 1,
        checkList: []
      },
      rules: {
        name: [isEmpty("请输入角色名称")],
        description: [isEmpty("请输入角色描述")],
        status: [isEmpty("请选择启用状态", "change")],
        checkList: [isEmpty("请选择角色权限", "blur")]
      },
      authList: []
    };
  },
  created() {
    this.loadAuthList();
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    loadAuthList() {
      this.$api("privilege", "getAuthEnumerate", {}).then((res) => {
        // console.log(res);
        this.authList = [
          {
            id: "0",
            name: "全选",
            dataList: res.dataList
          }
        ];
      });
    },
    handleCheck(data, { checkedKeys }) {
      this.form.checkList = checkedKeys;
      this.$refs["ruleForm"].validateField("checkList");
    },
    // resetChecked() {
    //   this.$refs.tree.setCheckedKeys([]);
    // },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        ...others
      } = this.form;
      return {
        ...others
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const { ...others } = data;
      return {
        ...others
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("privilege", "addRole", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("privilege", "addRole", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("privilege", "getRoleInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.data);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/systemManage/roleList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  /deep/ .my-tree {
    .el-tree-node__content {
      height: 30px;
    }
    .el-tree-node__children {
      .el-tree-node .el-tree-node {
        display: inline-block;
      }
    }
  }
}
</style>
